import React from "react";
import Image from "gatsby-image";
import {ArticlePhotos} from "./ArticlePhotos";
import OgImage from '../../../../assets/images/blog/article_8/og.png'
import {useAuthorsData} from "../../Authors/useAuthorsData";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();
  return {
    date: "14.05.2021r",
    category: "strona WWW, marketing internetowy",
    title:
      "Przewodnik po agencji interaktywnej, czyli czym jest i czym się zajmuje",
    image: OgImage,
    description:
      "Większość społeczeństwa potrafi odpowiedzieć na pytanie, jak działa i co robi agencja reklamowa. Ale interaktywna? Tutaj pojawia się problem. Co to jest agencja interaktywna i czym dokładnie się zajmuje? Odpowiedź znajdziecie poniżej. ",
    seo:
      "Większość społeczeństwa potrafi odpowiedzieć na pytanie, jak działa i co robi agencja reklamowa.",
    slug: "/blog/przewodnik_po_agencji_interaktywnej",
    authors: [
      authors.MariuszTrzeciak
    ],
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "",
        text: (
          <>
            Internet. To słowo jest kluczowe, ponieważ w XXI wieku śmiało można
            powiedzieć, że nie ma reklamy bez internetu. To właśnie tu w obecnym
            świecie przedsiębiorcy najczęściej decydują się na dotarcie do
            swoich klientów. Teraz nik t nie wyobraża sobie marki, która nie ma
            swojej strony internetowej czy profilu w social mediach. Jednak nie
            zawsze stworzenie miejsca online dla firmy jest takie proste. I
            wtedy z pomocą przychodzą agencje interaktywne.
            <br/>
            <br/>
            Ich zakres pracy skupia się na promowaniu marki właśnie w
            internecie. Agencje tego typu zajmują się e-marketingiem, czyli
            wszystkimi działaniami reklamowymi, które mają miejsce w sieci.
            Usługi agencji to nie tylko zaprojektowanie i stworzenie strony www.
            To również działania, które pozwolą reklamowanej marce wybić się
            wśród konkurencji, zapewnić jej rozwój i sprawić, że będzie ona
            postrzegana pozytywnie i zapisze się w świadomości odbiorców.
          </>
        ),
      },
      third: {
        title: "E-marketing - co to tak naprawdę jest?",
        text: (
          <>
            Jak już wcześniej zostało wspomniane, głównym zadaniem agencji
            interaktywnej jest wypromowanie biznesu w internecie. A to można
            zrobić na różne sposoby. Jednym z nich jest stworzenie strony
            internetowej lub sklepu online. To właśnie strona www jest
            najczęściej pierwszą formą kontaktu klienta z firmą i źródłem
            informacji na jej temat. Marka z profesjonalnie wykonaną stroną jest
            postrzegana jako wiarygodna i zasługująca na zaufanie. Agencje
            interaktywne zajmują się projektowaniem, programowaniem i
            kompleksowym prowadzeniem serwisów internetowych, systemów
            e-commerce i B2B, a nawet aplikacji mobilnych.
            <br/>
            <br/>
            Nie można też zapominać o social mediach. 3,80 miliarda - według
            najnowszych badań tylu użytkowników aktywnie korzysta z portali
            społecznościowych. Jest to o 321 milionów więcej niż na początku
            2019 roku. Specjaliści z agencji interaktywnych doskonale zdają
            sobie sprawę z mocy social mediów, dlatego oferują kreowanie i
            promowanie profili oraz wspomaganie ich działań. Do ich zadań należy
            redagowanie i publikowanie postów na Facebooku czy Instagramie,
            zamieszczanie fotografii, grafik i filmików czy informowanie na
            bieżąco swoich odbiorców o tym, co dzieje się w firmie.
            <br/>
            <br/>
            Zadania agencji interaktywnej to również dbanie o to, aby strona
            internetowa była wysoko pozycjonowana w wyszukiwarkach. Działania
            SEO i wykorzystywanie słów kluczowych to czynności, które pomogą w
            zwiększeniu widoczności strony w Google czy innych wyszukiwarkach.
            Agencje interaktywne przeprowadzają również audyty stron i sklepów
            internetowych, które pomagają w zbieraniu najważniejszych informacji
            - od funkcjonowania witryny do zachowań i preferencji klientów, co
            jest niezbędne w budowaniu silnej pozycji marki.
            <br/>
            <br/>
            Nie jest im również obce kreowanie wizerunku poprzez tworzenie
            spójnych systemów identyfikacji wizualnej. Odpowiednie logo czy
            kolorystyka wpływają na postrzeganie marki, a co za tym idzie -
            pozyskanie nowych klientów. Specjaliści agencji tworzą grafiki,
            zdjęcia czy filmy wideo, które stają się nieodłącznym elementem
            przyszłych kampanii marketingowych. Wszystko ma na celu pokazanie
            oferowanych produktów jak z najlepszej strony. Bardzo częstym
            zabiegiem, który wykonują agencje jest rebranding lub redesign
            stron, czyli najprościej mówiąc - odświeżenie wizerunku.
            <br/>
            <br/>
            Lista usług oferowanych przez agencje interaktywne jest długa i
            wydawać by się mogło, że jest skierowana do firm, które dopiero
            zaczynają swoją przygodę w biznesie. Nie do końca tak jest. Z usług
            agencji mogą tak naprawdę skorzystać wszyscy - nie ma znaczenia czy
            klient jest młodym przedsiębiorcą w małej firmie czy dużym
            koncernem, który już od wielu lat funkcjonuje na rynku. Działalność
            agencji jest na tyle szeroka, że jest w stanie odpowiedzieć na
            potrzeby wszystkich klientów.
          </>
        ),
      },
      fourth: {
        title: "",
        text: (
          <>

          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>

          </>
        ),
      },
      sixth: {
        title: "",
        text: (
          <>

          </>
        ),
      },
      seventh: {
        title: "",
        text: (
          <>

          </>
        ),
      },
      eighth: {
        title: "Kto pracuje w agencji interaktywnej?",
        text: (
          <>
            Agencja interaktywna to nie jedna osoba. To zgrany zespół
            profesjonalistów, którzy są w stanie zapewnić swoim klientom
            kompleksowe usługi. To programiści i graficy, ale też specjaliści
            sprzedaży i osoby odpowiedzialne za opiekę nad projektem oraz
            kontakt z klientem. To również dział social media, czyli pracownicy
            zajmujący się opieką nad profilami społecznościowymi oraz
            copywriterzy. Jednym słowem - sztab kreatywnych osób, którym zależy
            na sukcesie promowanej marki.{" "}
            <br/>
            <br/>
            Nie bez przyczyny agencje interaktywne od kilku lat cieszą się dużym
            zainteresowaniem, a klienci często korzystają z ich usług. Internet
            to potężne medium, które pozwala na kontakt ze światem, a co za tym
            idzie - pozyskanie klientów i stworzenie pozytywnego wizerunku
            marki. Dlatego warto zastanowić się nad współpracą właśnie z agencją
            interaktywną.
          </>
        ),
      },
      ninth: {
        title: "",
        text: (
          <>

          </>
        ),
      },
    },
    list: {
      first: {
        title: "Struktura agencji",
        content: [
          <><strong>HR</strong> - Kompletowanie dokumentów, pilnowanie umów, rozliczenia - jedyny dział, który to wszystko ogarnia!</>,
          <><strong>SALES</strong> - Rozmowy z klientami, dbanie o kontakt, przedstawianie oferty to tylko niektóre z obowiązków pracowników tego działu.</>,
          <><strong>PROJECT MANAGER</strong> - Dział, który nadzoruje projekty oraz czuwa, aby wszystkie prace przebiegały zgodnie z planem!</>,
          <><strong>MARKETING</strong> - To właśnie ten dział kreuje pozytywny wizerunek oraz tworzy strategie wspierające sprzedaż i promujące markę.</>,
          <><strong>DESIGN</strong> - Sztab kreatywnych osób, które dbają o wizualną część projektów i wykonują materiały reklamowe.</>,
          <><strong>PROGRAMMING</strong> - Dział, który język programowania zna od podszewki - tworzy systemy, strony i aplikacje online.</>
        ]
      }
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
    },
  };
};
